import { IReferralCampaign } from '../../pages/referral-campaign-container/share-type'
import { ReferralCampaignsAction } from './action'
import { SET_REFERRAL_CAMPAIGNS } from './constants'
import update from 'immutability-helper'

interface InitialState {
  referralCampaigns: IReferralCampaign[]
}

const initialState: InitialState = {
  referralCampaigns: [],
}

function referralCampaignsReducer(state = initialState, action: ReferralCampaignsAction) {
  switch (action.type) {
    case SET_REFERRAL_CAMPAIGNS:
      return update(state, { $merge: { referralCampaigns: action.payload } })
    default:
      return state
  }
}

export default referralCampaignsReducer
